import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import {ThemeService} from '@app/services/theme.service';
import {NavigationMenuService} from '@app/services/navigation-menu.service';
import {NavLayoutService} from '@app/services/nav-layout.service';
import {ProjectContextService} from '@app/services/project-context.service';
import { RouterLink } from '@angular/router';
import { NavTopMenuComponent } from '../nav-top-menu/nav-top-menu.component';
import { NavProjectSwitcherComponent } from '../nav-project-switcher/nav-project-switcher.component';
import { NavToolbarComponent } from '../nav-toolbar/nav-toolbar.component';
import { NavUserMenuComponent } from '../nav-user-menu/nav-user-menu.component';
import { NavBreadcrumbComponent } from '../nav-breadcrumb/nav-breadcrumb.component';
import { AsyncPipe } from '@angular/common';

/**
 * The bar across the top, in two layouts. With the top menu: logo, project switcher, the menu,
 * then the toolbar and account menu - the navbar as it always looked. With the side menu (and
 * on a phone): the breadcrumb takes the menu's place, with a hamburger when the menu is a
 * drawer. The toolbar and account menu are the same in both.
 */
@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header-legacy.scss', './nav-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, NavTopMenuComponent, NavProjectSwitcherComponent, NavToolbarComponent, NavUserMenuComponent, NavBreadcrumbComponent, AsyncPipe]
})
export class NavHeaderComponent {
  private navLayout = inject(NavLayoutService);
  private projectContext = inject(ProjectContextService);
  private menu = inject(NavigationMenuService);
  private themeService = inject(ThemeService);

  readonly layout$ = this.navLayout.state$;
  readonly context$ = this.projectContext.context$;
  readonly crumbs$ = this.menu.breadcrumb$;
  readonly available$ = this.menu.available$;
  readonly isInfluencer = this.menu.isInfluencer;
  readonly isDarkTheme$ = this.themeService.isDarkTheme$;

  openDrawer(): void {
    this.navLayout.openDrawer();
  }

  reload(): void {
    window.location.reload();
  }
}
